"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputOTP = InputOTP;
exports.InputOTPGroup = InputOTPGroup;
exports.InputOTPSlot = InputOTPSlot;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _inputOtp = require("input-otp");
var _cn = _interopRequireDefault(require("@/utils/cn"));
var _excluded = ["className", "containerClassName"],
  _excluded2 = ["className"],
  _excluded3 = ["index", "className"];
/* eslint-disable react/jsx-props-no-spreading, react/no-multi-comp */
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/** Shadcn-compatible OTP input used by Commerce Web. */
function InputOTP(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$containerClassNa = _ref.containerClassName,
    containerClassName = _ref$containerClassNa === void 0 ? '' : _ref$containerClassNa,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_inputOtp.OTPInput, (0, _extends2["default"])({
    "data-slot": "input-otp",
    containerClassName: (0, _cn["default"])('flex items-center gap-2 disabled:opacity-50', containerClassName),
    className: (0, _cn["default"])('disabled:cursor-not-allowed', className)
  }, props, {
    "data-sentry-element": "OTPInput",
    "data-sentry-component": "InputOTP",
    "data-sentry-source-file": "input-otp.tsx"
  }));
}
function InputOTPGroup(_ref2) {
  var _ref2$className = _ref2.className,
    className = _ref2$className === void 0 ? '' : _ref2$className,
    props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    "data-slot": "input-otp-group",
    className: (0, _cn["default"])('flex items-center', className)
  }, props, {
    "data-sentry-component": "InputOTPGroup",
    "data-sentry-source-file": "input-otp.tsx"
  }));
}
function InputOTPSlot(_ref3) {
  var index = _ref3.index,
    _ref3$className = _ref3.className,
    className = _ref3$className === void 0 ? '' : _ref3$className,
    props = (0, _objectWithoutProperties2["default"])(_ref3, _excluded3);
  var inputOTPContext = (0, _react.useContext)(_inputOtp.OTPInputContext);
  var _ref4 = (inputOTPContext === null || inputOTPContext === void 0 ? void 0 : inputOTPContext.slots[index]) || {},
    _char = _ref4["char"],
    hasFakeCaret = _ref4.hasFakeCaret,
    isActive = _ref4.isActive;
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    "data-slot": "input-otp-slot",
    "data-active": isActive,
    className: (0, _cn["default"])('relative flex h-9 w-9 items-center justify-center border border-gray-300 text-sm shadow-sm transition-all outline-none first:rounded-l-md last:rounded-r-md data-[active=true]:z-10 data-[active=true]:border-primary-regular data-[active=true]:ring-2 data-[active=true]:ring-primary-regular/30', className)
  }, props, {
    "data-sentry-component": "InputOTPSlot",
    "data-sentry-source-file": "input-otp.tsx"
  }), _char, hasFakeCaret && /*#__PURE__*/_react["default"].createElement("div", {
    className: "pointer-events-none absolute inset-0 flex items-center justify-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-4 w-px animate-pulse bg-primary-regular"
  })));
}